import React, { useState, useEffect, useRef } from 'react'
import { useThemeDetection } from '../hooks/useThemeDetection'

const ConfirmDialog = ({ isOpen, title, message, onConfirm, onCancel, confirmText = 'Confirm', cancelText = 'Cancel', confirmButtonClass = 'bg-red-600 hover:bg-red-700' }) => {
  const { isClearTheme } = useThemeDetection()
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [isDragging, setIsDragging] = useState(false)
  const dragStartRef = useRef({ x: 0, y: 0 })

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging) return
      e.preventDefault()
      setPosition({
        x: e.clientX - dragStartRef.current.x,
        y: e.clientY - dragStartRef.current.y
      })
    }

    const handleMouseUp = () => {
      if (isDragging) {
        setIsDragging(false)
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
      }
    }

    if (isDragging) {
      document.body.style.cursor = 'move'
      document.body.style.userSelect = 'none'
      window.addEventListener('mousemove', handleMouseMove)
      window.addEventListener('mouseup', handleMouseUp)
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('mouseup', handleMouseUp)
    }
  }, [isDragging])

  const handleDragStart = (e) => {
    e.preventDefault()
    setIsDragging(true)
    dragStartRef.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y
    }
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onCancel} />

      <div
        className={`relative rounded-xl shadow-2xl max-w-md w-full p-6 z-[111] ${
          isClearTheme ? 'bg-white text-gray-900' : 'bg-gray-800 text-white'
        }`}
        style={{
          transform: `translate(${position.x}px, ${position.y}px)`,
          position: 'relative'
        }}
      >
        <div
          className="cursor-move mb-4"
          onMouseDown={handleDragStart}
        >
          <h3 className={`text-xl font-bold mb-2 ${isClearTheme ? 'text-gray-900' : 'text-white'}`}>
            {title}
          </h3>
        </div>

        <p className={`mb-6 ${isClearTheme ? 'text-gray-600' : 'text-gray-300'}`}>
          {message}
        </p>

        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className={`px-4 py-2 font-medium rounded-lg transition-colors ${
              isClearTheme
                ? 'bg-gray-200 hover:bg-gray-300 text-gray-800'
                : 'bg-gray-700 hover:bg-gray-600 text-white'
            }`}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 text-white font-medium rounded-lg transition-colors ${confirmButtonClass}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmDialog
